<template>
    <div class="Shortcuts">
    <div class="MainTitle" v-if="TitleRef">
      <h3 class="MainTitle_RefTitle">{{TitleRef}}</h3>
    </div>
    <div class="Shortcuts-container">
      <div class="Shortcuts-row">
        <ul class="nav Shortcuts-nav" v-for="item of InfoView" :key="item.id">
          <h4 class="nav_hm_title col-md-12">{{item.title}}</h4>
          <a :href="item.link" data-toggle="lightbox" data-gallery="gallery" class="nav_hm_ref" :target="item.target">
          <img :src="item.img" class="nav_hm_img col-md-12"/>
          </a>
          <li class="nav-item Shortcuts-nav-item col-md-12">
            <a :href="item.link" data-toggle="lightbox" data-gallery="gallery" class="nav_hm_ref" :target="item.target">
              {{item.detail}}
            </a>
          </li>
        </ul>
      </div>
    </div>
    </div>
</template>

<script>
export default {
    name: 'Shortcuts',
    props: {
        InfoView: Array,
        TitleRef: String
    }    
}
</script>

<style scoped>

@import url('https://fonts.googleapis.com/css2?family=Montserrat&display=swap');

  *
  {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  html
  {
    font-size: 62.5%;
  }

  body
  {
    font-size: 1.6rem;
  }

  .Shortcuts-container
  {
    display: flex;
  }

.Shortcuts-row
  {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }

  .Shortcuts-nav
  {
    display: inline-block;
    padding: 1rem 2rem;
  }

  .nav_hm_title
  {
    text-align: center;
    margin: 1rem 0px;
  }

  .nav_hm_ref
  {
    font-family: 'Montserrat', sans-serif;
    display: inline-block;
    width: 100%;
    margin-top: 1rem;
    background-color: #fff;
    color: #222;
    border: #222 solid 3px;
    text-align: center;
  }

  .nav_hm_img
  {
    width: 80vw;;
  }

  .nav_hm_ref:hover
  {
    text-decoration: none;
    background-color: #222;
    color: #fff;
  }

  .nav_hm_ref:active
  {
    text-decoration: none;
    border-color: #A3A6AA;
    background-color: #A3A6AA;
    color: #fff;
  }

  .navItem
  {
    padding: 1rem 0.5rem;
  }

@media (min-width: 1024px)
  {
    .Shortcuts-row
    {
      display: flex;
      width: 1024px;
      margin: 1rem auto;
    }
    .Shortcuts-nav img
    {
      width: 300px;
      height: 200px;
      margin: 2rem 2rem;
    }
    .MainTitle_RefTitle
    {
      text-align: center;
      padding: 1rem 1rem;
    }
  }
</style>